import React from 'react';
import { formatLocalizedString } from '@/utils/i18n';
import LocalizedString from '@/types/localized-string';
import { Tooltip } from '@/views/components/tooltips';

type NameCellProps = {
  name?: LocalizedString;
};

const NameCell: React.FC<NameCellProps> = ({ name }) => {
  if (!name) return null;

  return (
    <Tooltip className="custom-tooltip-v2" message={formatLocalizedString(name)}>
      <span className="cell name-cell">{formatLocalizedString(name)}</span>
    </Tooltip>
  );
};

export default NameCell;
